import axios from "axios";
import {
    CREATE_SITE_MODEL_NUMBERS,
    DELETE_SITE_MODEL_NUMBERS,
    GET_SITE_MODEL_NUMBERS,
} from "../routes";

export default {
    async create(site, data, options = {}) {
        return await axios.post(CREATE_SITE_MODEL_NUMBERS(site), data, options);
    },

    async all(site, data, options = {}) {
        return await axios.get(GET_SITE_MODEL_NUMBERS(site), options);
    },

    async delete(site, model, options = {}) {
        return await axios.delete(DELETE_SITE_MODEL_NUMBERS(site, model), options)
    }
}
